export default __webpack_public_path__ + "static/media/sulfurousburst.4866d888.png";